<template>
  <div class="card bg-body-light" :class="[type && `card-${type}`]">
    <div class="card-image" v-if="$slots.image"><slot name="image"></slot></div>
    <div
      class="card-header"
      v-if="$slots.header || title"
      :class="headerClasses"
    >
      <sizeWidget v-if="name" :id="name"></sizeWidget>
      <slot name="header">
        <h4 class="card-title">{{ title }}</h4>
        <p class="card-category" v-if="subTitle">{{ subTitle }}</p>
      </slot>
    </div>
    <div class="card-body" v-if="$slots.default" :class="bodyClasses">
      <slot> </slot>
    </div>
    <div class="card-image" v-if="$slots['image-bottom']">
      <slot name="image-bottom"></slot>
    </div>
    <slot name="raw-content"></slot>
    <div class="card-footer" :class="footerClasses" v-if="$slots.footer">
      <hr v-if="showFooterLine" />
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
import sizeWidget from '../Widgets/components/sizeWidget.vue';
export default {
  name: "card",
  components:{
    sizeWidget
  },
  props: {
    title: {
      type: String,
      description: "Card title",
    },
    subTitle: {
      type: String,
      description: "Card subtitle",
    },
    type: {
      type: String,
      description: "Card type (e.g primary/danger etc)",
    },
    showFooterLine: {
      type: Boolean,
      default: false,
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes",
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes",
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes",
    },
    name: {
      type: [String],
      description: "Change Size For widget",
    },
  },
};
</script>
<style>
.pull-right {
  float: right;
}
.card-chart .card-header .card-category {
  margin-bottom: 5px;
}

.card {
  margin-bottom: 30px;
}
.card .card-header .card-title {
  font-weight: 100;
}
.form-group {
  margin-bottom: 1rem;
}
.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-sm,
.btn-group-sm > .btn {
  font-size: 0.875rem;
  border-radius: 0.2857rem;
  padding: 5px 15px;
}
card-chart .card-header .card-title i {
  font-size: 16px;
  margin-right: 5px;
  margin-bottom: 3px;
}
</style>
